import React from 'react';
import Navbar from '../Navbar/Navbar';
import About from '../About/About';
import Footer from '../Footer/Footer';

const AboutPage = () => {
  return (
    <div className='about-page'>
      <Navbar />
      <About />
      <Footer />
    </div>
  );
};

export default AboutPage;
